<template>
    <section class="bg-[#1f2826]">
        <div v-if="footerImage" class="w-full">
            <img class="w-full" :src="footerImage" alt="" loading="lazy" decoding="async" />
        </div>
        <div class="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-6 text-sm text-white/60 sm:px-5 md:flex-row md:items-center md:justify-between md:py-8">
            <p>PHOSPHENE ARCHITECTS</p>
            <p>Architecture / Interiors / Landscape / Lighting Design</p>
        </div>
    </section>
</template>

<script>
import { computed } from "vue";
import { useStorageFolder } from "@/composables/useStorageAssets";
import { storageFolders } from "@/config/storageSections";

export default {
    setup() {
        const { assets: footerImages } = useStorageFolder(storageFolders.footer);
        const footerImage = computed(() => footerImages.value[0] || "");

        return { footerImage };
    },
};
</script>

<style lang="scss" scoped>
</style>
